import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'

const AppClientesGestion = Loadable(lazy(() => import('./view/Clientes')))

export const clientesRoutesMap = {
  gestion: {
    path: '/clientes/gestion',
    name: 'Gestión de clientes',
  },
}
const clientesRoutes = [
  {
    path: clientesRoutesMap.gestion.path,
    element: <AppClientesGestion />,
    auth: authRoles.admin,
  },
]

export default clientesRoutes
